@switch(this.srvAppMode.mode$ | async) {
  @case (AppMode.WEB) {
    <ng-container *ngTemplateOutlet="WEB_SHELL"></ng-container>
  }
  @case (AppMode.DEMO) {
    @if (this.srvAppMode.isDemoUrl$() | async) {
      <ng-container *ngTemplateOutlet="DEMO_SHELL"></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="WEB_SHELL"></ng-container>
    }
  }
}

<ng-template #WEB_SHELL>
  <ng-container *ngIf="PlatformService.isMobile()">
    <ion-content [scrollY]="false" fullscreen="true" #content><ng-container *ngTemplateOutlet="MAIN_CONTENT"></ng-container></ion-content>
  </ng-container>

  <ng-container *ngIf="PlatformService.isBrowser()">
    <ng-container *ngTemplateOutlet="MAIN_CONTENT"></ng-container>
    <img *ngIf="webBeaconUrl" [src]="webBeaconUrl" class="webBecaon" referrerpolicy="no-referrer-when-downgrade" alt="" />
  </ng-container>
</ng-template>

<ng-template #DEMO_SHELL>
  <div class="demo-mode">
    <div class="demo-text-container">
      <router-outlet></router-outlet>    
    </div>
    <app-footer class="footer"></app-footer>
  </div>
</ng-template>

<ng-template #MAIN_CONTENT>
  <div class="overlay d-md-none" [@fadeInOut]="(srvRpDesign.getSidebarNav() | async) ? 'fadeIn' : 'fadeOut'" (click)="this.dismissSidebarNav()"> </div>

  <ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">

    <app-header *ngIf="(SkinService.isSkin_1()) || ((loggedIn | async) && menuType=== 'left')"></app-header>
    <app-top-header *ngIf="(!SkinService.isSkin_1()) &&  (loggedIn | async) && menuType === 'top'"></app-top-header>

    <div *ngIf="loggedIn | async" class="container content-padding mb-3">
      <div *ngIf="menuType === 'left'">
        <app-sidebar-nav></app-sidebar-nav>
        <div class="row">
          <div *ngIf="!hideSidebar" class="col-4 col-lg-3 d-none d-md-block">
            <app-sidebar></app-sidebar>
          </div>
          <div class="col-12 col-md-8 col-lg-9 pl-md-0">
            <div>
              <app-breadcrumb></app-breadcrumb>
            </div>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
      <div *ngIf="menuType === 'top'">
        <app-topbar-nav></app-topbar-nav>
        <div class="content">
          <div *ngIf="banner | async" class="banner mt-2" [ngClass]="{'d-none': (srvRpDesign.isS$ | async)}">
            <a [href]="banner.value?.link" target="_blank">
              <img [src]="banner.value?.image" width="220" class="img-fluid rounded" [alt]="banner.value?.name" alt="" />
            </a>
          </div>
          <div class="main">
            <div>
              <app-breadcrumb></app-breadcrumb>
            </div>
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
    <router-outlet *ngIf="!(loggedIn | async)"></router-outlet>

    <ng-container *ngIf="!hideFooter">
      <app-footer *ngIf="!(loggedIn | async) || ((loggedIn | async) && menuType=== 'left')" class="footer"></app-footer>
    </ng-container>
    <app-top-menu-footer *ngIf="(loggedIn | async) && menuType === 'top'"></app-top-menu-footer>
  </ng-container>


  <!-- Mobile Design -->
  <ng-container *ngIf="srvRpDesign.isMobile$ | async">
    <div class="h-100" [ngStyle]="this.getMobileViewBackgroundStyle()" class="root-background">

      <!-- PreLogin, note the content-padding is internal wrapped case by case -->
      <div *ngIf="!(loggedIn | async)" class="h-100">
        <router-outlet></router-outlet>
      </div>

      <!-- Post-Login -->
      <div *ngIf="loggedIn | async" class="h-100 container content-padding">
        <app-sidebar-mobile></app-sidebar-mobile>
        <router-outlet></router-outlet>
        <div class="bottom-nav-placeholder" *ngIf="this.srvRpDesign.isShowBottomNav() | async"></div>
        <app-bottom-bar-nav *ngIf="this.srvRpDesign.isShowBottomNav() | async"></app-bottom-bar-nav>
      </div>

    </div>
  </ng-container>

</ng-template>